import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

interface NewsBriefProps {
  items: NewsItem[];
}

export default function NewsBrief({ items }: NewsBriefProps) {
  return (
    <section className="w-full">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-950">最新影视资讯</h2>
          <p className="text-sm text-foreground-500 mt-1">掌握行业动态，了解热播内容</p>
        </div>
        <Link
          to="/news"
          className="flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
        >
          更多资讯 <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {items.slice(0, 4).map((item) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="shrink-0 w-28 h-20 sm:w-36 sm:h-24 rounded-md overflow-hidden bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title} 资讯配图`}
                title={`${item.title} - 蜜月TV影视资讯`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex flex-col">
              <span className="text-xs font-medium text-accent-700 mb-1">{item.category}</span>
              <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 hidden sm:block">
                {item.summary}
              </p>
              <span className="text-xs text-foreground-400 mt-auto pt-1.5 flex items-center gap-1">
                <i className="ri-time-line" /> {item.date}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}